// API
import { getHomePageV2Data } from '../api/HomePage.api';

// Types
import { ItemType } from 'Shared/types/MeetingItem.type';

// Constants
import HomePageConstants from 'Shared/constants/HomePage.constants';
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';

// Utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Schemas
import MeetingItemSchema from 'Shared/utils/normalizeJSON/schemas/MeetingItem.schema';

export const fetchHomePageDataSuccess = payload => ({
  type: HomePageConstants.Actions.FETCH_HOME_PAGE_DATA_SUCCESS,
  payload,
});

export const fetchHomePageData = ({ type }: { type?: ItemType | 'all' }) => dispatch => {
  const options = {
    data_format: QueryParamsConstants.Api.JSONAPI,
    type,
  };

  return getHomePageV2Data(options).then(response => {
    dispatch(fetchHomePageDataSuccess(normalizer(MeetingItemSchema, response.data)));
    return response;
  });
};
